export default "__VITE_ASSET__972e2221__"